import React, { useState } from 'react';

const ChildCreationForm = ({ currentLevel, onChildCreated }) => {
  const [nombre, setNombre] = useState('');

  const handleCreateChild = () => {
    currentLevel.fractales.push({ nombre, fractales: [] });
    onChildCreated();
    setNombre('');
  };

  return (
    <div>
      <input
        type="text"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        placeholder="Nombre del tema"
      />
      <button onClick={handleCreateChild}>+</button>
    </div>
  );
};

export default ChildCreationForm;
